import type { LanguageTexts } from './types';

export const it: LanguageTexts = {
  consentTitle: 'Cookie su questo sito',
  consentDescription:
    'Utilizziamo cookie necessari, senza i quali il sito non funziona. Con il tuo consenso utilizzeremmo anche cookie per {purposes}, compresi cookie di terze parti. Puoi modificare o revocare la tua scelta in qualsiasi momento con il pulsante nell’angolo in basso della pagina.',
  consentDescriptionNecessaryOnly:
    'Utilizziamo solo cookie necessari, senza i quali il sito non funziona. Non richiedono il tuo consenso.',
  controllerLine: 'Titolare del trattamento: {controller}.',
  acceptAll: 'Accetta tutti',
  rejectAll: 'Rifiuta tutti',
  preferences: 'Impostazioni',
  save: 'Salva la scelta',
  close: 'Chiudi',
  serviceCounter: 'servizio|servizi',
  preferencesTitle: 'Impostazioni dei cookie',
  introTitle: 'Come utilizziamo i cookie',
  introDescription:
    'I cookie sono piccoli file che un sito salva nel tuo browser. Scegli qui sotto quali consentire. I cookie necessari sono sempre attivi.',
  necessaryTitle: 'Cookie necessari',
  necessaryDescription:
    'Servono al funzionamento sicuro del sito e a ricordare la tua scelta sui cookie. Non richiedono il consenso.',
  categories: {
    functional: {
      title: 'Cookie funzionali',
      description: 'Abilitano funzioni aggiuntive, ad esempio mappe incorporate e impostazioni memorizzate.',
      purpose: 'funzioni aggiuntive',
    },
    analytics: {
      title: 'Cookie analitici',
      description:
        'Ci aiutano a capire come i visitatori usano il sito (ad esempio quali pagine sono più visitate), per poterlo migliorare.',
      purpose: 'la misurazione delle visite',
    },
    marketing: {
      title: 'Cookie pubblicitari',
      description:
        'Utilizzati da partner pubblicitari e fornitori di contenuti incorporati (ad esempio video) per mostrare annunci più pertinenti e misurarne l’efficacia. Possono tracciare le tue visite su altri siti.',
      purpose: 'la pubblicità',
    },
  },
  moreTitle: 'Ulteriori informazioni',
  moreDescription: 'Scopri di più sui cookie e sui tuoi diritti nella nostra {policyLink}.',
  policyLinkText: 'cookie policy',
  policyTitle: 'Cookie policy',
  and: 'e',
  poweredBy: 'Fornito da',
  revisitLabel: 'Impostazioni dei cookie',
  iframeNotice: 'Per mostrare questo contenuto è necessario il consenso a «{category}».',
  iframeButton: 'Consenti e mostra',
  tableName: 'Cookie',
  tableProvider: 'Fornitore',
  tablePurpose: 'Finalità',
  tableDuration: 'Durata',
  session: 'Sessione',
  consentCookiePurpose: 'Memorizza la tua scelta sui cookie.',
  otherCookiesTitle: 'Altri cookie',
  otherCookiesNote: 'Cookie di questo sito che Kockica non riconosce. Per i dettagli contatta il titolare.',
  noCookies: 'Su questa pagina non sono stati rilevati cookie che richiedono il consenso.',
};
